import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { IuserState } from "./user.types";

const selectDomain = (state: any) => state.userReducer;

export const user = createDraftSafeSelector(
  selectDomain,
  (user: IuserState) => user.user
);

export const users = createDraftSafeSelector(
  selectDomain,
  (users: IuserState) => users.users
);

export const singleUser = createDraftSafeSelector(
  selectDomain,
  (user: IuserState) => user.singleUser
);

export const successMessage = createDraftSafeSelector(
  selectDomain,
  (user: IuserState) => user.successMesssage
);

export const userError = createDraftSafeSelector(
  selectDomain,
  (user: IuserState) => user.userError
);

export const userActivityInProcess = createDraftSafeSelector(
  selectDomain,
  (user: IuserState) => user.isUserActivityInProcess
);
